import React from "react";
import { Navigate } from "react-router-dom";
import { validateToken } from "utils/checkAuthorization";
import { getUserDetails } from "../utils/localStorageServices";

const safeLocalStorageClear = () => {
  try {
    localStorage.clear();
  } catch {
    // Ignore storage errors in restricted iframe contexts.
  }
};

const buildLoginRedirect = () => {
  try {
    const currentPath = `${window.location.pathname}${window.location.search}`;
    return `/login?redirect=${encodeURIComponent(currentPath)}`;
  } catch {
    return "/login";
  }
};

export default function ProtectedRoute({ children }) {
  const tokenObject = getUserDetails();
  const token = tokenObject?.token;
  const isAuthenticated = Boolean(tokenObject && token && validateToken());

  if (!isAuthenticated) {
    safeLocalStorageClear();
    return <Navigate to={buildLoginRedirect()} replace />;
  }

  return children;
}
